import { createAPI } from '@common'
export default {
  // 获取验证码
  getValidateImageCode: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0wfsjgz0hfuWbmjebufJnbhfDpef', 'get', config),
  // 发送短信
  verifySmsSend: (config) =>
    createAPI('customEncryptApiName-1/0qspec0cbbt.nfttbhf0wfsjgz0tntTfoe', 'post', config),
  // 获取成员组
  getMemberGroupOptions: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bqq0hfuNfncfsHspvqjoh', 'get', config),
  // 获取会员列表
  getMemberList: (config) =>
    createAPI('customEncryptApiName-1/0qspec0nfncfs0tqd0w20bmmNfncfsJogp0hfuNfncfsEfubjm/ep',
      'post',
      config
    ),
  // 获取E5 actions
  getE5Actions: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt0f60bdujpot', 'get', config),
  // 获取E5 lists
  getE5Lists: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt0f60mjtut', 'get', config),
  // 系统消息列表
  getSystemMessageList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0f60mjtuebub', 'post', config),
  // 新建系统消息
  postSystemMessage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0tztNfttbhf0tbwf', 'post', config),
  // 删除系统消息
  deleteSystemMessage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0tztNfttbhf0efmfuf', 'post', config),
  // 获取系统消息详情
  getSystemMessageDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0tztNfttbhf0efubjm', 'get', config),
  // 发布系统消息
  postSystemMessagePublish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0tztNfttbhf0qvcmjti', 'post', config)
}
